<template>
  <div class="breadcrumb">
    <el-breadcrumb separator="/">
      <!-- <transition-group name="breadcrumb"> -->
      <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
        <span v-if="index == levelList.length - 1">
          {{ item.meta.title }}
        </span>
        <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
      </el-breadcrumb-item>
      <!-- </transition-group> -->
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {},
  computed: {},
  data() {
    return {
      levelList: [],
    };
  },
  watch: {
    $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      //   if (route.path.startsWith('/redirect/')) {
      //     return
      //   }
      this.getList();
    },
  },
  methods: {
    getList() {
      let matched = this.$route.matched.filter(
        (item) => item.meta && item.meta.title
      );
      this.levelList = matched.filter(
        (item) => item.meta && item.meta.title && item.meta.breadcrumb !== false
      );
    },
  },
  mounted() {
    // console.log(this.$route, "909090");
  },

  created() {
    this.getList();
  },
};
</script>


<style lang="scss" scoped>
.breadcrumb {
  width: 100%;
  height: 20px;
  display: flex;
  align-items: center;
  padding: 10px 0px 10px 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.07);
  position: fixed;
  z-index: 100;
  background-color: white;
}
</style>
